// extracted by mini-css-extract-plugin
export default {"header":"tZBD4IgvIngco2etdcqX"};